import { useState } from 'react';
import { ClientDto } from '../../../api';
import Clients from './clients/Clients';
import SelectProjects from './projects/SelectProjects';
import AllProjects from './projects/AllProjects';

function ClientsAndProjects() {
  const [selectedClient, setSelectedClient] = useState<ClientDto | undefined>(undefined);

  return (
    <div style={{ margin: '1rem' }}>
      <Clients selectedClient={selectedClient} setSelectedClient={setSelectedClient} />
      {selectedClient ? <SelectProjects selectedClient={selectedClient} /> : <AllProjects />}
    </div>
  );
}

export default ClientsAndProjects;
